import React from 'react';
import { formatPercentage } from 'shared/src/domain/line-item/line-item-utils';
import { cn } from '@/lib/utils';

type Props = {
  planned: number | null;
  target: number | null;
};
export function MarginIndicator({ planned, target }: Props) {
  const bgColor = calcBgColor(planned, target);
  const txtColor = calcTextColor(planned, target);
  return (
    <div className="flex flex-col gap-1 text-xs text-gray-600">
      <div className="flex items-center gap-2">
        <div className={cn('rounded px-1 font-semibold', bgColor, txtColor)}>
          {formatPercentage(planned || 0)}
        </div>
        <div>Campaign Planned Margin</div>
      </div>
      <div className="flex items-center gap-2">
        <div className={cn('rounded px-1 font-semibold', bgColor, txtColor)}>
          {calcMarginText(planned, target)}
        </div>
        <div className="font-semibold">vs. {formatPercentage(target || 0)} Target Margin</div>
      </div>
    </div>
  );
}

function calcMarginText(planned: number | null, target: number | null) {
  if (planned === null || target === null) return undefined;
  if (planned === target) return 'On-Target';
  const diff = Math.abs(planned - target) / target;
  if (planned > target) {
    return `${formatPercentage(diff)} Premium`;
  }
  return `${formatPercentage(diff)} Discount`;
}

function calcBgColor(planned: number | null, target: number | null) {
  if (planned === null || target === null) return undefined;
  if (planned === target) return 'bg-lime-100';
  if (planned > target) return 'bg-yellow-100';
  return 'bg-red-100';
}

function calcTextColor(planned: number | null, target: number | null) {
  if (planned === null || target === null) return undefined;
  if (planned === target) return 'text-lime-700';
  if (planned > target) return 'text-yellow-700';
  return 'text-red-700';
}
